<script setup lang="ts">
const props = withDefaults(defineProps<{
  fast?: boolean
  iconClass?: string
}>(), {
  fast: undefined,
  iconClass: 'text-2xl',
})
const { locale } = useI18n()

const carrierLogos = [
  { name: 'carrier:ceska-posta', locales: ['cs'], fast: false },
  { name: 'carrier:slovenska-posta', locales: ['sk'], fast: false },
  { name: 'carrier:magyar-posta', locales: ['hu'], fast: false },
  { name: 'carrier:poste-italiane', locales: ['it'], fast: false },
  { name: 'carrier:la-poste', locales: ['fr'], fast: false },
  { name: 'carrier:colissimo', locales: ['fr'], fast: true },
  { name: 'carrier:colis-prive', locales: ['fr'], fast: true },
  { name: 'carrier:correos', locales: ['es'], fast: false },
  { name: 'carrier:mrw', locales: ['es'], fast: true },
  { name: 'carrier:deutsche-post', locales: ['de'], fast: false },
  { name: 'carrier:dhl', locales: ['de', 'nl'], fast: true },
  { name: 'carrier:dpd', locales: ['hu', 'de', 'at'], fast: true },
  { name: 'carrier:expressone', locales: ['sk', 'ro'], fast: true },
  { name: 'carrier:imile', locales: ['it'], fast: true },
  { name: 'carrier:cttexpress', locales: ['es'], fast: true },
  { name: 'carrier:cirro-parcel', locales: ['fr'], fast: true },
  { name: 'carrier:romanian-post', locales: ['ro'], fast: false },
  { name: 'carrier:zasilkovna', locales: ['cs'], fast: true },
  { name: 'carrier:astria-post', locales: ['at'], fast: false },
  { name: 'carrier:ukrposhta', locales: ['uk'], fast: true },
  { name: 'carrier:gls', locales: ['pl', 'it', 'nl'], fast: true },
  { name: 'carrier:inpost', locales: ['pl'], fast: true },
  { name: 'carrier:packeta', locales: ['sk', 'pl'], fast: true },
  { name: 'carrier:poczta-polska', locales: ['pl'], fast: false },
  { name: 'carrier:post-nl', locales: ['nl'], fast: false },
  { name: 'carrier:peddler', locales: ['nl'], fast: true },
]

const icons = computed(() => {
  const current = locale.value.toLowerCase()

  const carriers = carrierLogos.filter(c =>
    c.locales.length === 0 || c.locales.includes(current),
  )
  if (props.fast === true) {
    return carriers.filter(c => c.fast)
  }
  if (props.fast === false) {
    return carriers.filter(c => !c.fast)
  }

  return [...carriers].sort((a, b) => Number(b.fast) - Number(a.fast))
})
</script>

<template>
  <div class="flex items-center gap-x-2 overflow-x-auto no-scrollbar">
    <div
      v-for="icon in icons"
      :key="icon.name"
      class="flex items-center justify-start rd-md bg-gray-1 px2 py1"
    >
      <Icon
        :name="icon.name"
        class="rd-sm"
        :class="props.iconClass"
      />
    </div>
  </div>
</template>
